export default "__VITE_ASSET__e04253e8__"